import React, { useRef } from 'react';

import _ from 'lodash';
import { Link } from 'react-router-dom';
import { Button, Paper } from '@material-ui/core';

import { useMessageSender, useSocket } from 'hooks';
import { backLink, call } from 'utils';
import { ButtonContainer } from 'components';
import { ChatPreview, ChatSender, EventHeader } from '../../shared';
import { InteractionList, TemplateList, UserSelector } from '../../shared';

import styles from './ChannelMessages.module.scss';

const ChannelMessages = ({ event, back }) => {
  const templateList = useRef(null);
  const interactionList = useRef(null);
  const eventHeader = useRef(null);

  const { setFilter, sendMessage } = useMessageSender(event);

  useSocket(
    'webapp/control',
    { join: event._id },
    {
      refreshActiveInteractions: () => {
        call((templateList.current || {}).reload);
        call((interactionList.current || {}).reload);
      },
      updateOnline: users => call((eventHeader.current || {}).setOnlineUsers, users),
    }
  );

  return (
    <div className={styles.channelMessages}>
      <ButtonContainer position="top">
        <Button variant="text" component={Link} to={back}>
          back to channel list
        </Button>
      </ButtonContainer>

      <EventHeader ref={eventHeader} event={event} />

      <div className={styles.body}>
        <div className={styles.left}>
          <UserSelector
            event={event}
            title="Select how new global messages will be delivered."
            onChange={setFilter}
            chatFilter
            hints={{
              default: 'New messages will be delivered to all individual SKYDOME chats',
              users:
                'New messages will be delivered to individual SKYDOME chats of the selected users',
            }}
          />

          <TemplateList ref={templateList} event={event} onMessage={sendMessage} />
          <InteractionList ref={interactionList} event={event} onMessage={sendMessage} />
        </div>

        <Paper className={styles.right}>
          <ChatPreview event={event} />
          <ChatSender event={event} onMessage={sendMessage} />
        </Paper>
      </div>
    </div>
  );
};

const ChannelMessagesGuard = props => {
  const event = useRef();

  if (!event.current) {
    const { eventId, channelId, channelName } = _.get(props, 'location.state') || {};

    if (channelId && channelName && eventId) {
      event.current = {
        id: eventId,
        _id: eventId,
        isGlobal: true,
        channel: { _id: channelId, name: channelName },
      };
    } else {
      props.history.push(backLink(props));
      return null;
    }
  }

  return <ChannelMessages event={event.current} back={backLink(props)} />;
};

export default ChannelMessagesGuard;
